// extracted by mini-css-extract-plugin
export default {"block":"AskQuestions__block___PW316","blockTitle":"AskQuestions__blockTitle___t6Xp1","title":"AskQuestions__title___m30y0","small":"AskQuestions__small___D1y7r"};